var path = '/pages/guestlists/views/pages/guestlists/protected-files.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<section ng-if=\"!vm.loading\">\n    <div class=\"heading-toolset-wrapper\">\n        <h1>Protected files</h1>\n    </div>\n\n    <al-guestlist-protected-files guestlist=\"vm.guestlist\"></al-guestlist-protected-files>\n</section>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/protected-files.tpl.html
// module id = 2267
// module chunks = 1